import request from "@/utils/request";
import axios from "axios";


//test
export function text(data) {
    return request({
        url: 'https://api-sepolia.etherscan.io/api',
        method: 'get',
        params: data
    })
}


//登录
export function login(data) {
    return request({
        url: '/web/user/add',
        method: 'post',
        data: data
    })
}

//获取用户信息
export function getUserInfo(data) {
    return request({
        url: '/web/user/' + data,
        method: 'get'
    })
}

export function getRecordList(data) {
    return request({
        url: 'https://api-sepolia.etherscan.io/api',
        method: 'get',
        params: data
    })

}

//添加订单（购买权益）
export function addOrder(data) {
    return request({
        url: '/web/orders/add',
        method: 'post',
        data
    })
}


//文件上传
export function upLoadFile(data) {
    return request({
        url: '/web/file/uploadOnline',
        // url: '/web/file/upload',
        method: 'post',
        data
    })
}


//获取我的质押总数
export function getPledgeTotal(data) {
    return request({
        url: '/web/user/getImpawnTotal/' + data,
        method: 'get'
    })
}

//获取团队列表
export function getTeamList(data) {
    return request({
        url: '/web/user/groupList',
        method: 'get',
        params: data
    })
}
// 获取我的团队
export function getMyTeamList(address,data) {
    return request({
        url: `/system/impawnUser/selectImpawnUserTeam/${address}`,
        method: 'get',
		params: data
    })
}
//获取直推列表
export function getPushList(data) {
    return request({
        url: '/web/user/pushList',
        method: 'get',
        params: data
    })
}

//获取荐点列表
export function getRecommendList(data) {
    return request({
        url: '/web/user/recommendList',
        method: 'get',
        params: data
    })
}


//新增质押
export function addPledge(data) {
    return request({
        url: '/web/record/add',
        method: 'post',
        data
    })
}

//查询质押记录列表
export function getPledgeList(data) {
    return request({
        url: '/web/record/list',
        method: 'get',
        params: data
    })
}

//修改质押(自动续签，解压)
export function updataPledge(data) {
    return request({
        url: '/web/record/edit',
        method: 'put',
        data
    })
}

// 查询利息释放记录列表
export function getInterestReleaseList(data) {
    return request({
        url: '/system/interestRelease/awardList',
        method: 'get',
        params: data
    })
}

// 充值记录
export function getRechargeRecord(data) {
    return request({
        url: '/web/rechargeRecord/list',
        method: 'get',
        params: data
    })
}
//从区块链获取交易记录
export function getRecordForEth(data) {
    return request({
        url: 'https://api-sepolia.etherscan.io/api',
        method: 'get',
        params: data
    })
}


//新增充值记录（我的页面提现）
export function addRechargeRecord(data) {
    return request({
        url: '/web/rechargeRecord/add',
        method: 'post',
        data
    })
}

//查询充值记录列表（提现申请列表）
export function getRechargeRecordList(data) {
    return request({
        url: '/web/rechargeRecord/list',
        method: 'get',
        params: data
    })
}

//修改充值记录（软删除,修改体现）
export function updataRechargeRecordList(data) {
    return request({
        url: '/web/rechargeRecord/edit',
        method: 'put',
        data
    })
}


//修改用户（修改钱包余额）
export function editUserInfo(data) {
    return request({
        url: '/web/user/edit',
        method: 'put',
        data
    })
}

//购买算力
export function purchaseComputingPower(data) {
    return request({
        url: '/web/user/buySai',
        method: 'post',
        data
    })
}

//购买燃料(自购)(收益钱包)
export function buyGSOfIncome(data) {
    return request({
        url: '/web/user/buyGS',
        method: 'post',
        data
    })
}


//购买燃料(赠送)(收益钱包)
export function buyGS1OfIncome(data) {
    return request({
        url: '/web/user/buyGS1',
        method: 'post',
        data
    })
}

//购买燃料(自购)(流动钱包)
export function buyGSOfFlow(data) {
    return request({
        url: '/web/user/buy1GS',
        method: 'post',
        data
    })
}


//购买燃料(赠送)(流动钱包)
export function buyGS1OfFlow(data) {
    return request({
        url: '/web/user/buy1GS1',
        method: 'post',
        data
    })
}


//查询奖励池列表(全网算力)
export function getPoolList(data) {
    return request({
        url: '/web/pool/list',
        method: 'get',
        params: data
    })
}

//解押
export function impawnEnd(data) {
    return request({
        url: '/web/user/impawnEnd',
        method: 'post',
        data
    })
}
// 新增预约质押返还记录
export function postReservationRecord(data) {
    return request({
        url: '/system/reservationRecord/add',
        method: 'post',
        data
    })
}

//查询用户等级列表
export function getUserLevelList(data) {
    return request({
        url: '/web/userLevel/list',
        method: 'get',
        params: data
    })
}

//绑定邀请人
export function bindInviter(data) {
    return request({
        url: '/web/user/changeCode',
        method: 'post',
        data
    })
}


//查询账户异常状态
export function getUserStatus(data) {
    return request({
        url: '/web/user/getStatus/' + data,
        method: 'get'

    })
}


//解析积分
export function exchangeCredits(data) {
    return request({
        url: '/web/rechargeRecord/exchangeCredits',
        method: 'post',
        data
    })
}

//获取字典详细信息
export function getDictDetail(data) {
    return request({
        url: '/web/dict/' + data,
        method: 'get'
    })
}


//转赠
export function tradeTo(data) {
    return request({
        url: '/web/orders/tradeTo',
        method: 'post',
        data: data
    })
}


//数据统计
export function dataStatisticsApi(data) {
    return request({
        url: '/web/statistics/list',
        method: 'get',
        params: data
    })
}

//购买电量
export function buyElectricity(data) {
    return request({
        url: '/web/user/resetGetGHS',
        method: 'post',
        data
    })
}


//总算力
export function getTotalSai(data) {
    return request({
        url: '/web/user/getTotalSai',
        method: 'get',

    })
}

//测试
export function test(data) {
    return request({
        url: '/web/rechargeRecord/importRecord/' + data,
        method: 'get',
    })
}


//修改支付密码
export function changePasswordMethod(data) {
    return request({
        url: '/web/user/resetPayPassword',
        method: 'post',
        data
    })
}


//添加待查询记录
export function addScanRecord(data) {
    return request({
        url: '/system/record',
        method: 'post',
        data
    })
}


//带查询记录列表
export function getScanRecord(data) {
    return request({
        url: '/system/record/list',
        method: 'get',
        params: data
    })
}

//查询
export function editScanRecord(data) {
    return request({
        url: '/system/record',
        method: 'put',
        data: data
    })
}


//删除
export function deleteScanRecord(data) {
    return request({
        url: '/system/record/' + data,
        method: 'delete',
    })
}


//签到
export function singe(data) {
    return request({
        url: '/system/sign/add',
        method: 'post',
        data
    })
}

//获取签到列表
export function getSinge(data) {
    return request({
        url: '/system/sign/list',
        method: 'get',
        params: data
    })
}


//验证提现支付是否成功
export function isPayM(data) {
    return request({
        url: '/web/rechargeRecord/checkTransaction',
        method: 'post',
        data: {
            id: data
        }
    })
}

//预览文件
export function getPdfStream() {
    return axios.get('http://192.168.1.184:8080/web/file/download/天使保障基金.pdf', {
        responseType: 'arraybuffer',
        headers: {
            'Content-Disposition': 'inline;filename=example.pdf'
        }
    })
}


//获取币种市场最近高价
export function getMarketHighestPrice(data) {
    return request({
        url: '/web/orders/getMarketPriceMax',
        method: 'get',
    })
}
